import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classes from '../../../../../cartAndOrders/index.module.scss'
import { Package } from '../../../../../cartAndOrders/orderInformation/components/methodPayment/Package'
import {
  getCartItems,
  getUserPricingPackages,
} from '../../../../../cartAndOrders/store/thunk'
import { selectUserType } from '../../../../../layout/store/slice'
import { selectDetails } from '../../../orderManagement/orderDetail/store/slice'
import { selectDataByIdOrder } from '../../../orderManagement/store/slice'
import { getDataReportPackage } from '../../helper'

export const PackageMethod = ({
  isScreening,
  orderId,
  setDisablePackage,
  isShowInvalidPackage,
}) => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const locale = useSelector((state) => state.i18n.locale)
  const dataById = useSelector(selectDataByIdOrder)
  const dataDetailsInDetailOrder = useSelector(selectDetails)

  const dataReportPackage = useMemo(
    () =>
      getDataReportPackage(
        dataById[orderId]?.details || dataDetailsInDetailOrder,
      ),
    [],
  )

  useEffect(() => {
    dispatch(getCartItems({ userType: userType.userTypeId }))
    dispatch(
      getUserPricingPackages({
        GroupByReportType: true,
      }),
    )
  }, [locale])

  return (
    <div
      className={classes.orderInformationContainer}
      style={{ width: '100%', padding: 0, marginTop: 16 }}
    >
      <div className={classes.paymentMethodContainer} style={{ padding: 0 }}>
        <Package
          isScreening={isScreening}
          dataReportUserManagement={dataReportPackage}
          setDisablePackage={setDisablePackage}
          isShowInvalid={isShowInvalidPackage}
        />
      </div>
    </div>
  )
}
